import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useApiConfig } from "@visioni/a3s-client-api/app";
import { vehiclesQuery } from "../queries";
import { filtersToApiQuery } from "../filter-params";
import type { VehicleFilters } from "../../types";

interface UseVehiclesOptions {
  filters: VehicleFilters;
  selectedSiteId: string | null;
  cursor?: string;
  sort?: "asc" | "desc";
}

export function useVehicles({ filters, selectedSiteId, cursor, sort }: UseVehiclesOptions) {
  const apiConfig = useApiConfig();

  const queryParams = filtersToApiQuery(filters, selectedSiteId, cursor, sort);
  const base = vehiclesQuery(apiConfig, {}, queryParams);

  return useQuery({
    ...base,
    enabled: !!filters.startDate && !!filters.endDate,
    refetchOnMount: "always",
    refetchOnWindowFocus: true,
    ...(cursor ? { placeholderData: keepPreviousData } : {}),
  });
}
